module.exports = "/images/vendor/flag-icon-css/flags/1x1/iq.svg?8d936728f892c7f38e61ff6a95b24c53";